/**
 * jQuery.lazyTube
 * On-demand loading for YouTube videos, with support for other services by custom callbacks
 * Avoid hanging your client's browsers by loading YouTube videos ONLY when they want to watch them
 * @version  1.1
 * @author   biohzrdmx <github.com/biohzrdmx>
 * @requires jQuery 1.8+
 * @license  MIT
 */
;!function (e) {
    e.fn.lazyTube = function (a) {
        if (!this.length) return this;
        var t = e.extend(!0, {}, e.lazyTube.defaults, a);
        return this.each(function () {
            var a = e(this), n = a.data("id") || null, i = a.data("thumbnail") || "mqdefault",
                d = a.data("autoplay") || "no", r = a.data("autoload") || !1, l = a.data("width") || "480",
                u = a.data("height") || "270", o = a.data("target") || "self",
                c = (a.data("flags"), a.children(".preview"));
            0 == c.length && (c = e('<a href="#" class="preview"></a>'), a.prepend(c));
            var f = t.thumbnailCode(a, n, i);
            c.append(f), c.on("click", function (i) {
                switch (o) {
                    case"self":
                        var r, f = f || "rel=0&wmode=transparent" + ("yes" == d ? "&autoplay=1" : ""),
                            h = t.embedCode(a, l, u, n, f);
                        r = e(h), c.hide(), a.append(r);
                        break;
                    default:
                        var s = t.targetHandlers[o];
                        "function" == typeof s && s.call(a, t, {id: n, width: l, height: u, autoplay: d})
                }
                i.preventDefault()
            }), "yes" == r && e(window).on("load", function () {
                c.trigger("click")
            })
        }), this
    }, e.lazyTube = {
        defaults: {
            targetHandlers: {}, thumbnailCode: function (e, a, t) {
                return '<img src="//img.youtube.com/vi/' + a + "/" + t + '.jpg" alt="" />'
            }, embedCode: function (e, a, t, n, i) {
                return '<div class="embed"><iframe width="' + a + '" height="' + t + '" src="//www.youtube-nocookie.com/embed/' + n + "?" + i + '" frameborder="0" allowfullscreen></iframe></div>'
            }
        }
    }
}(jQuery);